import type { LlmModel } from '@@types/api.types';
import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

export type LlmModelStore = {
  selectedModel?: LlmModel;

  // Actions
  setSelectedModel: (model: LlmModel) => void;
  clearSelectedModel: () => void;
};

export const llmModelStore = createStore<LlmModelStore>()(
  persist(
    (set) => ({
      selectedModel: undefined,

      setSelectedModel: (selectedModel) => set({ selectedModel }),
      clearSelectedModel: () => set({ selectedModel: undefined }),
    }),
    { name: 'llmModelStore' },
  ),
);
